/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_People_HintInputs */

const cs_settings_venues_people_hint = /** @type {(inputs: Settings_Venues_People_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidi přiřaďte na stránce Uživatelé.`)
};

const en_settings_venues_people_hint = /** @type {(inputs: Settings_Venues_People_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign people on the Users page.`)
};

/**
* | output |
* | --- |
* | "Assign people on the Users page." |
*
* @param {Settings_Venues_People_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_people_hint = /** @type {((inputs?: Settings_Venues_People_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_People_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_people_hint(inputs)
	return cs_settings_venues_people_hint(inputs)
});